import { render, staticRenderFns } from "./customer_list.vue?vue&type=template&id=54f89019"
import script from "./customer_list.vue?vue&type=script&lang=js"
export * from "./customer_list.vue?vue&type=script&lang=js"
import style0 from "./customer_list.vue?vue&type=style&index=0&id=54f89019&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports